exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-tag-modal .user-tag-content[data-v-c762663e] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  min-height: 200px;\n  text-align: center;\n}\n.user-tag-modal .user-tag-image[data-v-c762663e] {\n  max-width: 480px;\n  max-height: 480px;\n  object-fit: contain;\n  margin: 0 auto;\n}\n.user-tag-modal .btn[data-v-c762663e] {\n  background-color: #90cc1b;\n}", ""]);

// exports
